export const Rail = ({ id, label, className = "", labelClass = "text-inkmuted", children }) => (
  <section id={id} className={`py-14 sm:py-24 md:py-32 ${className}`}>
    <div className="max-w-6xl mx-auto px-5 sm:px-6 grid md:grid-cols-[220px_1fr] gap-6 sm:gap-12">
      <p className={`lb ${labelClass}`}>{label}</p>
      <div className="min-w-0">{children}</div>
    </div>
  </section>
);
